// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__TzlhL","empty":"ModalGraph_empty__3gFqT"};